import Image from "next/image";

import { useTranslation } from "@flare/i18n";
import { Heading, Text } from "@flare/ui/components";

import { ActionButton } from "../components/action-button";
import { ActionsContainer } from "../components/actions-container";
import { BackButton } from "../components/back-button";
import { Footer } from "../components/footer";
import { StepContainer } from "../components/step-container";
import { StepContent } from "../components/step-content";

import type { StepProps } from "./step.types";

export default function PreferencesSummary({ answers }: StepProps) {
  const { attorneyQualities, updatePreference, stateDisplayText } = answers;
  const { t } = useTranslation();

  const updatePreferenceLowerCases =
    updatePreference && updatePreference.toLowerCase();
  const attorneyQualitiesLowerCases =
    attorneyQualities && attorneyQualities.toLowerCase();

  const subtitle =
    stateDisplayText && updatePreference && attorneyQualities
      ? t("FUNNEL_PREFERENCES_SUMMARY_DYNAMIC_SUBTITLE", {
          state: stateDisplayText,
          updatePreference: updatePreferenceLowerCases,
          attorneyQualities: attorneyQualitiesLowerCases,
        })
      : t("FUNNEL_PREFERENCES_SUMMARY_FALLBACK_SUBTITLE");

  return (
    <>
      <StepContainer>
        <StepContent>
          <BackButton />
          <div className="m-auto flex w-full max-w-[1010px] flex-col items-center justify-between gap-sp-7 py-sp-6 md:flex-row md:pt-sp-9">
            <div className="w-full md:w-1/2">
              <Heading
                variant="h3"
                textWrap="balance"
                className="text-center md:text-left"
              >
                {t("FUNNEL_PREFERENCES_SUMMARY_TITLE")}
              </Heading>
              <Text className="mt-sp-3 max-w-[450px] text-center md:mb-sp-8 md:mt-sp-6 md:text-left">
                {subtitle}
              </Text>
            </div>
            <div className="relative w-full rounded-xl md:w-1/2">
              <Image
                src="/next/images/Legal-strategy.png"
                alt={t("FUNNEL_PREFERENCES_SUMMARY_IMAGE_ALT")}
                layout="responsive"
                width={503}
                height={420}
                className="rounded-lg md:hidden"
              />
              <Image
                src="/next/images/Legal-strategy.png"
                alt={t("FUNNEL_PREFERENCES_SUMMARY_IMAGE_ALT")}
                layout="responsive"
                width={485}
                height={458}
                className="hidden rounded-lg md:block"
              />
            </div>
          </div>
        </StepContent>
        <ActionsContainer>
          <ActionButton> {t("FUNNEL_ACTION_BUTTON_NEXT")}</ActionButton>
        </ActionsContainer>
      </StepContainer>
      <Footer />
    </>
  );
}
